import React, { useState } from "react"
import { AccordionItem, MobileLink } from "./index"
import { useProgramSections, ProgramSection } from "@lib/hooks/data/useProgramSections"

const ProgramPanelSkeleton = () => (
  <div className="grid gap-2 py-1 pl-8 pr-5" aria-busy="true" aria-label="Memuat program">
    {[0, 1, 2].map((key) => (
      <div key={key} className="h-9 rounded-lg bg-grey-ec animate-pulse" />
    ))}
  </div>
)

const ProgramSectionAccordion = ({
  section,
  open,
  onToggle,
}: {
  section: ProgramSection
  open: boolean
  onToggle: () => void
}) => {
  return (
    <AccordionItem
      title={section.title}
      open={open}
      onToggle={onToggle}
      nested
      panelClassName="!pl-8"
    >
      {section.items.map((item) => (
        <MobileLink key={item.slug} link={section.buildLink(item.slug)} className="!px-0">
          {item.name}
        </MobileLink>
      ))}
    </AccordionItem>
  )
}

export const ProgramAccordion = () => {
  const { visibleSections, isLoading, showProgramNav } = useProgramSections()
  const [programOpen, setProgramOpen] = useState(false)
  const [openSectionKey, setOpenSectionKey] = useState<string | null>(null)

  if (!showProgramNav) {
    return null
  }

  const toggleProgram = () => {
    setProgramOpen((current) => {
      if (current) {
        setOpenSectionKey(null)
      }
      return !current
    })
  }

  const toggleSection = (key: string) => {
    setOpenSectionKey((current) => (current === key ? null : key))
  }

  return (
    <AccordionItem title="Program" open={programOpen} onToggle={toggleProgram} panelClassName="!px-0">
      {isLoading ? (
        <ProgramPanelSkeleton />
      ) : (
        <div className="grid gap-0">
          {visibleSections.map((section) => (
            <ProgramSectionAccordion
              key={section.key}
              section={section}
              open={openSectionKey === section.key}
              onToggle={() => toggleSection(section.key)}
            />
          ))}
        </div>
      )}
    </AccordionItem>
  )
}
